import { BaseListService } from '/@/modules/core/table/services/BaseListService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { EstateAccountRow } from '/@/modules/estateaccount/models/EstateAccountRow';

export class EstateAccountListService extends BaseListService {
  getRoute() {
    return Route.ESTATEACCOUNTS_ALL;
  }

  getModel() {
    return EstateAccountRow;
  }

  addParams(params = {}) {
    params.with
      ? params.with.push(
          'role',
          'user.contact.contactAliases',
          'user.estateAccounts',
          'user.company'
        )
      : (params.with = [
          'role',
          'user.contact.contactAliases',
          'user.estateAccounts',
          'user.company'
        ]);
    return super.addParams(params);
  }
}

export default new EstateAccountListService();
